// `load` — find a record, then edit it or start a new one; shown only when it
// stopped (not found with `on_missing: "error"`, nothing picked).

import AutoStep from './AutoStep'
import type { StepProps } from './common'

export default function LoadStep(props: StepProps) {
  return <AutoStep {...props} retryLabel="Look again" note="The record could not be opened." />
}
